<script>
import ReleaseDialog from "@/views/warn/release/ReleaseDialog.vue";
export default {
  components: { ReleaseDialog },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      queryForm: {
        date: [this.$moment(this.$moment().toDate()).subtract(1, 'month').format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')],
        current: 1,
        total: 0,
        size: 10,
        yjzt: 3
      },
      yjlbbhList: [],
      yjlevelList: [],
      yjztList: [
        {code: 0, name: '新产生'},
        {code: 3, name: '需发布'},
        {code: 1, name: '自动关闭'},
        {code: 2, name: '手动关闭'}
      ],
      smsztList: [
        {code: false, name: '未发布'},
        {code: true, name: '已发布'}
      ],
      release: {
        visible: false,
        formData: {
          useridList: []
        },
        userList: []
      }
    }
  },
  methods: {
    init() {
      this.request.get('/rm-sdictionary/v1/query/07').then(
          (res) => {
            if (res.ok) {
              this.yjlbbhList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
      this.request.get('/rm-sdictionary/v1/query/11').then(
          (res) => {
            if (res.ok) {
              this.yjlevelList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
      this.query();
    },
    clear() {
      this.queryForm = {
        date: [this.$moment(this.$moment().toDate()).subtract(1, 'month').format('YYYY-MM-DD'), this.$moment(new Date()).format('YYYY-MM-DD')],
        current: 1,
        total: 0,
        size: 10,
        yjzt: 3
      };
      this.$refs.multipleTable.clearSort();
      this.$refs.multipleTable.clearSelection();
      this.query();
    },
    tableRowClassName() {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.2rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
      };
    },
    handleSizeChange(val) {
      this.queryForm.size = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.queryForm.current = val;
      this.page();
    },
    page() {
      this.queryForm.tmGT = this.queryForm.date[0] + ' 00:00:00';
      this.queryForm.tmLE = this.queryForm.date[1] + ' 23:59:59';
      this.request.post('/rm-tyjxx/queryYjxxPage', this.queryForm).then(
          (res) => {
            if (res.ok) {
              this.tableData = res.data.records;
              this.queryForm.total = res.data.total;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    query() {
      this.queryForm.current = 1;
      this.page();
    },
    yjztReset() {
      this.queryForm.yjzt = '';
      this.query();
    },
    releaseHandle(val) {
      this.release.formData.yjxxid = val.id;
      this.request.get(`/rm-tyjusergx/queryYjUserList/${this.release.formData.yjxxid}`).then(
          (res) => {
            if (res.ok) {
              this.release.userList = res.data;
              this.release.visible = true;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    yjlbbhReset() {
      this.queryForm.yjlbbh = '';
      this.query();
    },
    smsztReset() {
      this.queryForm.smszt = '';
      this.query();
    },
    sortChange({ prop, order }) {
      this.queryForm.sortCol = prop;
      this.queryForm.order = order;
      this.queryForm.current = 1;
      this.page();
    },
  },
  mounted() {
    this.init();
  },
  watch:{
    "$store.state.head.skCd"() {
      //调用页面查询方法
      this.query();
    },
  }
}
</script>

<template>
  <el-container style="padding: 20px;">
    <el-header>
      <el-row>
        <el-col :span="24" style="display: flex;align-items: center;">
          <el-input
              v-model="queryForm.stcdnm"
              :maxlength="11"
              placeholder="预警对象"
              style="width: 200px;margin: 0 10px;">
          </el-input>
          <el-date-picker
              v-model="queryForm.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              style="margin-right: 10px;"
              :clearable="false"
              size="small">
          </el-date-picker>
          <el-button
              type="primary"
              size="small"
              style="background-color: #a8a8a8;border-color: #a8a8a8;"
              @click="clear">
            重置
          </el-button>
          <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="query">
            搜索
          </el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="commonDiv">
      <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%;"
          height="calc(100% - 60px)"
          max-height="calc(100% - 60px)"
          border
          @sort-change="sortChange"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'5rem'}"
          :row-style="tableRowClassName">
        <el-table-column
            prop="yjlbnm"
            align="center">
          <template #header>
            <span>预警类别</span>
            <el-popover
                placement="bottom"
                trigger="click"
                width="200">
              <el-select v-model="queryForm.yjlbbh" @change="query" style="margin-right: 10px;" placeholder="预警类别">
                <el-option
                    v-for="item in yjlbbhList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
              <el-row style="margin-top: 2vh;">
                <el-col :span="12">
                  <el-button class="dgSave" @click="yjlbbhReset">重 置</el-button>
                </el-col>
              </el-row>
              <i slot="reference" class="el-icon-sxld"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
            prop="yjlevelmc"
            label="预警等级"
            align="center">
          <template v-slot="scope">
            <span v-if="scope.row.yjlevelmc === '关注'" style="color: #FA9001;">{{ scope.row.yjlevelmc }}</span>
            <span v-if="scope.row.yjlevelmc === '警戒'" style="color: #EA3323;">{{ scope.row.yjlevelmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="300"
            label="预警对象">
          <template v-slot="scope">
            <span>{{scope.row.stnm}}（{{scope.row.stcd}}）</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="yjqssj"
            align="center"
            width="180"
            sortable="custom"
            label="预警开始时间">
        </el-table-column>
        <el-table-column
            prop="yjjssj"
            align="center"
            width="180"
            label="预警结束时间">
        </el-table-column>
        <el-table-column
            prop="yjzt"
            align="center">
          <template #header>
            <span>预警状态</span>
            <el-popover
                placement="bottom"
                trigger="click"
                width="200">
              <el-select v-model="queryForm.yjzt" placeholder="预警状态" @change="query">
                <el-option
                    v-for="item in yjztList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
              <el-row style="margin-top: 2vh;">
                <el-col :span="12">
                  <el-button class="dgSave" @click="yjztReset">重 置</el-button>
                </el-col>
              </el-row>
              <i slot="reference" class="el-icon-sxld"></i>
            </el-popover>
          </template>
          <template v-slot="scope">
            <span v-if="scope.row.yjzt === 0" style="color: #4CA93B;">新产生</span>
            <span v-if="scope.row.yjzt === 1" style="color: #323232;">自动关闭</span>
            <span v-if="scope.row.yjzt === 2" style="color: #323232;">手动关闭</span>
            <span v-if="scope.row.yjzt === 3" style="color: #EA3323;">需发布</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="nr"
            width="300"
            label="内容">
          <template v-slot="scope">
            <el-tooltip effect="light" :disabled="scope.row.nr.length < 30" class="el-tooltip-omit">
              <div class="omit">{{ scope.row.nr }}</div>
              <template #content>
                <div :style="{ width: 200 + 'px' }">{{ scope.row.nr }}</div>
              </template>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            prop="smszt"
            align="center">
          <template #header>
            <span>发布状态</span>
            <el-popover
                placement="bottom"
                trigger="click"
                width="200">
              <el-select v-model="queryForm.smszt" placeholder="发布状态" @change="query">
                <el-option
                    v-for="item in smsztList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
              <el-row style="margin-top: 2vh;">
                <el-col :span="12">
                  <el-button class="dgSave" @click="smsztReset">重 置</el-button>
                </el-col>
              </el-row>
              <i slot="reference" class="el-icon-sxld"></i>
            </el-popover>
          </template>
          <template v-slot="scope">
            <span v-if="scope.row.smszt" style="color: #323232;">已发布</span>
            <span v-else style="color: #EA3323;">未发布</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button @click="releaseHandle(scope.row)" type="text" size="small">发布</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="commonPage">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total="queryForm.total"
            :current-page.sync="queryForm.current"
            :page-size="queryForm.size"
            layout="total, prev, pager, next,sizes, jumper">
        </el-pagination>
      </div>
    </el-main>
    <release-dialog :release="release"></release-dialog>
  </el-container>
</template>

<style scoped>
::v-deep .el-input__inner {
  height: 32px;
}

::v-deep .el-input--suffix .el-input__inner {
  width: 100% !important;
}

::v-deep  .el-input__icon{
  line-height: 27px !important;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 208px);
  padding: 20px 20px 0 20px;
}

.commonPage {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}

/deep/ .el-pagination{
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}

::v-deep .el-range-separator {
  line-height: 24px;
}

.omit {
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.el-icon-sxld {
  width: 10px;
  height: 9px;
  margin-left: 10px;
  cursor: pointer;
  background: url('../../assets/icons/sxld.png');
}

.dgSave {
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>